export default __webpack_public_path__ + "static/media/illustration_reset.82255120.svg";